import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Edit from '@mui/icons-material/Edit';
import Close from '@mui/icons-material/Close';
import Save from '@mui/icons-material/Save';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import TablePagination from '@mui/material/TablePagination';
import PaginacionControl from '../components/PaginacionControl';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import Add from '@mui/icons-material/Add';
import GetApp from '@mui/icons-material/GetApp';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import PublicIcon from '@mui/icons-material/Public';

const initialForm = {
  fecha: dayjs().format('YYYY-MM-DD'),
  compra: '',
  venta: ''
};
// import { Box, Typography, Button, TextField, Paper, Grid } from '@material-ui/core';
// import Alert from '@material-ui/lab/Alert';
// import { DatePicker } from '@material-ui/pickers';
import dayjs from 'dayjs';
import axios from 'axios';

const TipoCambio = () => {
    const columns = [
      { id: 'fecha', label: 'Fecha', minWidth: 100 },
      { id: 'compra', label: 'Compra', minWidth: 80 },
      { id: 'venta', label: 'Venta', minWidth: 80 },
      { id: 'fuente', label: 'Fuente', minWidth: 120 },
      { id: 'acciones', label: 'Acciones', minWidth: 80 }
    ];
  const [fecha, setFecha] = useState(dayjs());
  const [compra, setCompra] = useState('');
  const [venta, setVenta] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ ...initialForm });
  // Consulta tipo de cambio SOLO por API (para el botón Consultar TC)
  const consultarTipoCambioPorFecha = async (fecha) => {
    setMensaje('');
    setError('');
    try {
      const res = await axios.get(`/api/tipo-cambio/sunat?fecha=${fecha}`);
      if (res.data && res.data.compra && res.data.venta) {
        setForm(f => ({ ...f, compra: res.data.compra, venta: res.data.venta, fuente: res.data.fuente }));
        let fuente = res.data.fuente ? (res.data.fuente.toLowerCase().includes('api') ? 'API' : res.data.fuente.toUpperCase()) : 'API';
        setMensaje(`TC ${fuente}: Compra ${res.data.compra} / Venta ${res.data.venta}`);
        setError('');
      } else {
        setForm(f => ({ ...f, compra: '', venta: '', fuente: '' }));
        setMensaje('No se encontró tipo de cambio para la fecha');
        setError('');
      }
    } catch (err) {
      setForm(f => ({ ...f, compra: '', venta: '', fuente: '' }));
      setMensaje('');
      setError('No se pudo consultar tipo de cambio (API).');
    }
  };
  const [editing, setEditing] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    handleFilter();
  }, [search, data]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axios.get('/api/tipo-cambio');
      setData(res.data);
    } catch (err) {
      setData([]);
    }
    setLoading(false);
  };

  const handleFilter = () => {
    if (!search) setFiltered(data);
    else setFiltered(data.filter(row =>
      row.fecha.includes(search) ||
      (row.compra + '').includes(search) ||
      (row.venta + '').includes(search)
    ));
    setPage(0);
  };

  const handleExport = () => {
    (async () => {
      const { exportGenericWorkbook } = await import('../utils/excel/genericWorkbook');
      const rows = filtered.map(row => ({
        fecha: row.fecha ? row.fecha.substring(0, 10) : '',
        compra: row.compra,
        venta: row.venta,
        fuente: row.fuente ? (row.fuente.toLowerCase().includes('api') ? 'API' : row.fuente) : '-'
      }));
      await exportGenericWorkbook({
        titulo: 'REPORTE - TIPO DE CAMBIO',
        sheetName: 'TipoCambio',
        tableName: 'tblTipoCambio',
        fileName: 'TipoCambio',
        columns: [
          { key: 'fecha', label: 'Fecha', width: 16 },
          { key: 'compra', label: 'Compra', width: 14 },
          { key: 'venta', label: 'Venta', width: 14 },
          { key: 'fuente', label: 'Fuente', width: 20 }
        ],
        rows,
        searchText: search,
        usuario: ''
      });
    })();
  };

  const buscarEnBD = async (fecha) => {
    setMensaje('');
    setError('');
    try {
      const resBD = await axios.get('/api/tipo-cambio');
      const tc = resBD.data.find(x => x.fecha && x.fecha.substring(0,10) === fecha);
      if (tc) {
        setForm(f => ({ ...f, compra: tc.compra, venta: tc.venta, fuente: tc.fuente }));
        setMensaje(`TC ${tc.fuente && tc.fuente.toLowerCase().includes('api') ? 'API' : tc.fuente}: Compra ${tc.compra} / Venta ${tc.venta}`);
        setError('');
      } else {
        setForm(f => ({ ...f, compra: '', venta: '', fuente: '' }));
        setMensaje('');
        setError('');
      }
    } catch (err) {
      setForm(f => ({ ...f, compra: '', venta: '', fuente: '' }));
      setMensaje('');
      setError('No se pudo consultar la base de datos.');
    }
  };

  const handleOpen = (row = null) => {
    if (row) {
      // Asegurar formato YYYY-MM-DD para la fecha
      let fecha = row.fecha ? row.fecha.substring(0, 10) : '';
      setForm({ fecha, compra: row.compra, venta: row.venta, fuente: row.fuente });
      setEditing(row.id);
    } else {
      const hoy = dayjs().format('YYYY-MM-DD');
      setForm({ fecha: hoy, compra: '', venta: '', fuente: '' });
      setEditing(null);
      buscarEnBD(hoy);
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setForm(initialForm);
    setEditing(null);
  };

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => {
      const nuevo = { ...prev, [name]: value };
      if (name === 'fecha') {
        nuevo.compra = '';
        nuevo.venta = '';
        nuevo.fuente = '';
        setMensaje('');
        setError('');
        buscarEnBD(value);
      }
      return nuevo;
    });
  };

  const handleSubmit = async () => {
    if (!form.fecha || !form.compra || !form.venta) return;
    try {
      const fuente = form.fuente ? (form.fuente.toLowerCase().includes('api') ? 'apis.net.pe' : form.fuente) : 'apis.net.pe';
      const payload = { ...form, fuente };
      // Verificar si ya existe en la BD
      const resBD = await axios.get('/api/tipo-cambio');
      const existe = resBD.data.find(x => x.fecha && x.fecha.substring(0,10) === form.fecha);
      if (existe && !editing) {
        if (!window.confirm('Ya existe un tipo de cambio para esta fecha. ¿Desea actualizarlo?')) return;
        await axios.put(`/api/tipo-cambio/${existe.id}`, payload);
      } else if (editing) {
        await axios.put(`/api/tipo-cambio/${editing}`, payload);
      } else {
        await axios.post('/api/tipo-cambio', payload);
      }
      fetchData();
      handleClose();
    } catch (err) {
      alert('Error al guardar tipo de cambio');
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" sx={{ textAlign: { xs: 'center', md: 'center' }, mb: 2, fontWeight: 'bold' }}>Tipo de Cambio</Typography>
      <Box sx={{ width: { xs: '100%', sm: '95%', md: '90%' }, maxWidth: 900, mx: 'auto' }}>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
          <TextField
            label="Buscar"
            value={search}
            onChange={e => setSearch(e.target.value)}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            sx={{ flex: 1 }}
          />
          <Button variant="contained" color="success" startIcon={<GetApp />} onClick={handleExport} sx={{ minWidth: 120 }}>Exportar Excel</Button>
          <Button variant="contained" color="primary" startIcon={<Add />} onClick={() => handleOpen()} sx={{ ml: { xs: 0, sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>Nuevo TC</Button>
          <TextField
            size="small"
            label="Mostrar"
            type="number"
            value={rowsPerPage}
            onChange={e => { setRowsPerPage(Number(e.target.value)); setPage(0); }}
            sx={{ width: 100 }}
          />
        </Box>
        <TableContainer component={Paper} sx={{ borderRadius: 4, boxShadow: 4, mt: 2, overflowX: 'auto' }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                {columns.map(col => (
                  <TableCell key={col.id} align="center" style={{ minWidth: col.minWidth, fontWeight: 'bold', background: '#1976d2', color: '#fff' }}>{col.label}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow><TableCell colSpan={columns.length} align="center">Cargando...</TableCell></TableRow>
              ) : filtered.length === 0 ? (
                <TableRow><TableCell colSpan={columns.length} align="center">Sin resultados</TableCell></TableRow>
              ) : (
                filtered
                  .slice(rowsPerPage === -1 ? 0 : page * rowsPerPage, rowsPerPage === -1 ? undefined : (page + 1) * rowsPerPage)
                  .map(row => (
                    <TableRow key={row.id} hover>
                      <TableCell align="center">{row.fecha ? row.fecha.substring(0, 10) : ''}</TableCell>
                      <TableCell align="center">{row.compra}</TableCell>
                      <TableCell align="center">{row.venta}</TableCell>
                      <TableCell align="center">{row.fuente ? (row.fuente.toLowerCase().includes('api') ? 'API' : row.fuente) : '-'}</TableCell>
                      <TableCell align="center">
                        <Tooltip title="Editar"><IconButton color="primary" onClick={() => handleOpen(row)}><Edit /></IconButton></Tooltip>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <PaginacionControl page={page} rowsPerPage={rowsPerPage} count={filtered.length} onPageChange={setPage} />
      </Box>
      <Dialog open={open} onClose={(_, r) => r !== 'backdropClick' && handleClose()} disableEscapeKeyDown={false} maxWidth="xs" fullWidth>
        <DialogTitle fontWeight="bold">{editing ? 'Editar Tipo de Cambio' : 'Nuevo Tipo de Cambio'}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} alignItems="center" justifyContent="center" textAlign="center">
            <Grid item xs={12} sm={7}>
              <TextField
                label="Fecha"
                name="fecha"
                type="date"
                value={form.fecha}
                onChange={handleChange}
                fullWidth
                sx={{ mt: 1 }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={5}>
              <Button
                variant="outlined"
                color="info"
                onClick={() => consultarTipoCambioPorFecha(form.fecha)}
                startIcon={<PublicIcon />}
                sx={{ mt: 1, width: '100%' }}
              >
                CONSULTAR TC
              </Button>
            </Grid>
            {mensaje && (
              <Grid item xs={12}>
                <Typography variant="body2" color="success.main" sx={{ mb: 1 }}>{mensaje}</Typography>
              </Grid>
            )}
            {error && (
              <Grid item xs={12}>
                <Typography variant="body2" color="error.main" sx={{ mb: 1 }}>{error}</Typography>
              </Grid>
            )}
            <Grid item xs={12} sm={6} sx={{ minWidth: '21.4em' }}>
              <TextField
                label="Compra"
                name="compra"
                type="number"
                value={form.compra}
                onChange={handleChange}
                fullWidth
                sx={{ mb: 0, '& input': { textAlign: 'center' } }}
                inputProps={{ step: '0.0001' }}
              />
            </Grid>
            <Grid item xs={12} sm={6} sx={{ minWidth: '21.4em' }}>
              <TextField
                label="Venta"
                name="venta"
                type="number"
                value={form.venta}
                onChange={handleChange}
                fullWidth
                sx={{ mb: 0, '& input': { textAlign: 'center' } }}
                inputProps={{ step: '0.0001' }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="error" variant="contained" startIcon={<Close />} sx={{ fontWeight: 'bold' }}>
            Cancelar
          </Button>
          <Button onClick={handleSubmit} color="success" variant="contained" startIcon={<Save />} sx={{ fontWeight: 'bold' }}>
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TipoCambio;

